import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import PatientSignupLayout from '../../components/patientSignup/PatientSignupLayout/PatientSignupLayout';
import PublicPatientScheduling from '../../components/booking/PublicPatientScheduling';
import { 
  setDate, 
  setTime, 
  setSessionTypeId, 
  setProviderAvailabilityId,
  setProviderId,
  setServiceType,
  setLocationType,
  setLocationId,
  setTimeCreated,
  setScheduleManually,
  // setError,
  reset,
} from '../../redux/reducers/newAppointmentForm';
import { setVisitorUUID } from '../../redux/reducers/analytics';
import { useCreateVisitorMutation } from '../../redux/services/visitorApi';

const trackVisitor = async ({
  createVisitor, 
  saveVisitorUUID,
}) => {
  let body = {
    scheduling_step: 'VISITED_SITE',
  };
  const response = await createVisitor(body);
  if (response?.data) saveVisitorUUID(response.data.uuid);
};

const PublicBookingPage = (props) => {
  const [stepIndex, setStepIndex] = useState(0);
  const uuid = props?.uuid;
  const navigate = useNavigate();
  const [createVisitor, trackerResponse] = useCreateVisitorMutation();
  console.log('RESPONSE', trackerResponse);
  useEffect(() => {
    props.reset();
    if (!uuid && !trackerResponse?.isSuccess) {
      trackVisitor({
        createVisitor,
        saveVisitorUUID: props.saveVisitorUUID,
      });
    }
  }, []);
  const childProps = {
    ...props,
    stepTitle: 'Find the perfect provider',
    step: stepIndex + 1,
    numSteps: 6,
    stepIndex: stepIndex,
    setStepIndex: setStepIndex,
  };
  return (
    <PatientSignupLayout {...childProps}>
      <Stack alignItems='center' pr={0}>
        <Box 
          style={{
            marginTop: '0em',
            paddingTop: stepIndex === 0 ? '2em' : '0em',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: '16px',
            backgroundColor: '#ffffff',
            border: '1px solid rgb(240,240,240)',
            width: '100%',
          }}
        >
          <PublicPatientScheduling
            {...props}
            stepIndex={stepIndex}
            setStepIndex={setStepIndex}
            afterSubmit={({providerId}) => {
              navigate(`/new-account?alreadyScheduled=true&selectedProviderId=${providerId}&version=v2`);
            }}
          />
        </Box>
      </Stack>
    </PatientSignupLayout>
  );
};

const mapState = state => {
  console.log('PublicBookingPage.state.newAppointmentForm', state.newAppointmentForm);
  return {
    uuid: state?.analytics?.visitorUUID,
  };
};

const mapDispatch = dispatch => ({
  saveDate: dateStr => dispatch(setDate(dateStr)),
  saveTime: timeStr => dispatch(setTime(timeStr)),
  saveSessionTypeId: sessionTypeId => dispatch(setSessionTypeId(sessionTypeId)),
  saveProviderAvailabilityId: providerAvailabilityId => 
    dispatch(setProviderAvailabilityId(providerAvailabilityId)),
  saveProviderId: providerId => dispatch(setProviderId(providerId)),
  saveServiceType: serviceType => dispatch(setServiceType(serviceType)),
  saveLocationType: locationType => dispatch(setLocationType(locationType)),
  saveLocationId: locationId => dispatch(setLocationId(locationId)),
  saveTimeCreated: timeCreated => dispatch(setTimeCreated(timeCreated)),
  saveScheduleManually: scheduleManually => dispatch(setScheduleManually(scheduleManually)),
  reset: () => dispatch(reset()),
  saveVisitorUUID: uuid => dispatch(setVisitorUUID(uuid)),
});

export default connect(mapState, mapDispatch)(PublicBookingPage);